import React from 'react';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Modal from '@common/components/Modal';
import userPersonas from '@common/constants/userPersonas';
import SpinnerContainer from '@common/components/SpinnerContainer';
import DebouncedButton from '@common/components/DebouncedButton';

interface CancelMoveInCostsModalProps {
  tenantFirstName: string;
  groupKey: string;
  isMICAllowed: boolean;
  goToDashboard: (tenantFirstName: string) => void;
  cancelMoveInCosts: (args: { groupKey: string }) => any;
  createMoveInCosts: () => void;
  onClose: () => void;
  onBack: () => void;
}

interface CancelMoveInCostsModalState {
  isLoading: boolean;
}

class CancelMoveInCostsModal extends React.Component<CancelMoveInCostsModalProps, CancelMoveInCostsModalState> {
  state = {
    isLoading: false,
  };

  showLoadingScreen = (): void => {
    this.setState({ isLoading: true });
  };

  hideLoadingScreen = (): void => {
    this.setState({ isLoading: false });
  };

  onCancelMoveInCosts = async (): Promise<void> => {
    this.showLoadingScreen();
    const { tenantFirstName, groupKey } = this.props;
    const result = await this.props.cancelMoveInCosts({ groupKey });
    this.hideLoadingScreen();
    if ((result && result.success) || (result && result.payload && result.payload.success)) {
      this.props.goToDashboard(tenantFirstName);
    }
  };

  onSubmit = async (): Promise<void> => {
    this.showLoadingScreen();
    const { groupKey } = this.props;
    const result = await this.props.cancelMoveInCosts({ groupKey });
    this.hideLoadingScreen();
    if ((result && result.success) || (result && result.payload && result.payload.success)) {
      this.props.createMoveInCosts();
    }
  };

  onClose = (): void => {
    this.props.onClose();
  };

  onBack = (): void => {
    this.props.onBack();
  };

  render(): React.ReactNode {
    const { isLoading } = this.state;
    const { isMICAllowed } = this.props;
    return (
      <Modal
        persona={userPersonas.LANDLORD}
        header="PAYMENT ACTIVITY"
        onRequestClose={this.onClose}
        dataAutoTestId="landlord-post-confirmation"
      >
        {isLoading && <SpinnerContainer />}
        <Row>
          <Col>
            <Text type="h3">Are you sure you want to cancel this move-in cost?</Text>
          </Col>
        </Row>
        <Row>
          <Col>
            <DebouncedButton full type="primary" onClick={this.onCancelMoveInCosts}>
              Yes, cancel
            </DebouncedButton>
          </Col>
        </Row>
        {isMICAllowed && (
          <Row>
            <Col>
              <DebouncedButton type="primary" full onClick={this.onSubmit}>
                Cancel and create a new Move-in cost
              </DebouncedButton>
            </Col>
          </Row>
        )}
        <Row>
          <Col>
            <Button full type="tertiary" onClick={this.onBack}>
              Nevermind, go back
            </Button>
          </Col>
        </Row>
      </Modal>
    );
  }
}

export default CancelMoveInCostsModal;
